// Imports
import { PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';


// Function component
const SignInAnchor: React.FC<PropsWithChildren> = ({ children }) => {
	// Use React Router functionality
	const location = useLocation();
	
	
	// Return JSX
	return (
		<a
			href={`https://${window.location.hostname}/oauth/initiate?redirect-uri=${encodeURIComponent(
				`${location.pathname}${location.search}${location.hash}`
			)}`}
		>
			{children}
		</a>
	);
};

export default SignInAnchor;
